import { useContext } from 'react';
import { EventContext } from '../Event/EventContext';
export default function useEventContext() {
    const context = useContext(EventContext);
    if (!context) {
        throw new Error('useEventContext must be used within a EventContextProvider');
    }
    return context;
}
